import React, { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { SwipeableDrawer } from '@mui/material';
import { LinearProgress } from '@mui/material';
import { isMobile } from '../../global/ScreenSizeHelper';
import { getUrlPath } from '../../global/getUrl';
import { localStorageKeys } from '../../global/constants';
import moment from 'moment-timezone';
import { io } from 'socket.io-client';
import Loader from '../Loader/Loader';
import RippleAnimation from '../../atomic/RippleAnimation/RippleAnimation';

import './OrderTrackingLive.scss';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
const formattedDateTime = () => {
  return moment().format('MM/DD/YYYY - hh:mm A');
};
// const socket = io("http://localhost:3006") // Notification Server path

const OrderTrackingLive = (props) => {
  const navigate = useNavigate();
  const handleClickRedirect = async () => navigate(`/customeraccount/orders`);
  const { openLiveOrderTracking, setOpenLiveOrderTracking, GetOrderStatus, orderStatusResponse } =
    useContext(GlobalStateDataContext);
  const { onLogout } = useContext(LoginDataContext);
  const drawerContainerRef = useRef();
  const [orderStatus, setOrderStatus] = useState('order canceled by customer');
  const checkUrlOrderConfirm = getUrlPath() === '/orderconfirmation';
  const firstProgress = [
    'pending',
    'order accepted by kitchen',
    'order canceled by kitchen',
    'super admin canceled the order',
    'order canceled by customer',
    'order canceled by computer no response from kitchen',
  ];
  const secondProgress = [
    'order ready for pickup',
    'driver pickup pending',
    'driver picked the order',
    'order_unpicked_by_driver',
  ];
  const thirdProgress = [
    'driver is at the door',
    'order delivered',
    'order_damaged_while_delivery',
    'order picked in store by customer',
  ];
  const [connectionStatus, setConnectionStatus] = useState('Disconnected');
  const [notificationServerDown, setNotificationServerDown] = useState(false);
  const { TOKEN, DEBUG_LOGOUT_POINT } = localStorageKeys;
  const hasTokens = localStorage.getItem(TOKEN);
  const [Dta, setDta] = useState(orderStatusResponse?.data?.data);
  const setLocalStorageDebug = async (param1, param2) => localStorage.setItem(param1, param2);

  const LoadingStatus = orderStatusResponse?.loading;
  const triggerLogout = async () => {
    await onLogout();
    navigate('/onthemenu');
    window.location.reload();
    setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'OrderTrackingLive() NO-0551');
  };
  let EmailAddress = null;
  if (hasTokens) {
    const decodedToken = jwt_decode(hasTokens);
    const { email } = decodedToken || null;
    EmailAddress = email;
  }

  useEffect(() => {
    if (orderStatusResponse?.data?.data) {
      setDta(orderStatusResponse?.data?.data);
    }
  }, [orderStatusResponse?.data?.data]);

  const payload = {
    // "date" : "10/02/2023",
    customer_email: EmailAddress,
  };

  const updateOrderData = (arg) => {
    if (arg.joined_order_no) {
      setDta((prevData) => {
        const newOrderData = prevData?.joinedOrders?.map((item) => {
          if (arg.joined_order_no === item.joined_order_no) {
            item.mealOrder.internal_order_status = arg.internal_order_status;
            item.mealOrder.delivery_time_slot = arg.delivery_time_slot;
            item.mealOrder.delivery_type = arg.delivery_type;
            item.mealOrder.delivery_date = arg.delivery_date;
          }

          return item;
        });

        return {
          ...prevData,
          joinedOrders: newOrderData,
        };
      });
    }
    if (!arg.joined_order_no && arg.order_no.includes('PAY')) {
      setDta((prevData) => {
        const newOrderData = prevData?.payAsYouGoOrders?.map((item) => {
          if (arg.order_no === item.order_no) {
            item.internal_order_status = arg.internal_order_status;
            item.delivery_time_slot = arg.delivery_time_slot;
            item.delivery_type = arg.delivery_type;
            item.delivery_date = arg.delivery_date;
          }

          return item;
        });

        return {
          ...prevData,
          payAsYouGoOrders: newOrderData,
        };
      });
    }
    if (!arg.joined_order_no && arg.order_no.includes('MEAL')) {
      setDta((prevData) => {
        const newOrderData = prevData?.mealOrders?.map((item) => {
          if (arg.order_no === item.order_no) {
            item.internal_order_status = arg.internal_order_status;
            item.delivery_time_slot = arg.delivery_time_slot;
            item.delivery_type = arg.delivery_type;
            item.delivery_date = arg.delivery_date;
          }

          return item;
        });

        return {
          ...prevData,
          mealOrders: newOrderData,
        };
      });
    }
  };

  const socketRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  useEffect(() => {
    const URL_PATH_NOTIFICATION_SERVER = process.env.REACT_APP_NOTIFICATION_SERVER_URL;
    const RELOAD_LOCK_KEY = 'customer_socket_reloaded_once';
    let reloadTimer = null;

    const socket = io(URL_PATH_NOTIFICATION_SERVER, {
      reconnection: true,
      reconnectionAttempts: Infinity,
      forceNew: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 2000,
      timeout: 5000,
      query: {
        type: 'customer_frontend_app',
        customerEmail: EmailAddress,
      },
      transports: ['websocket'],
      auth: {
        token: localStorage.getItem(TOKEN),
      },
    });

    socketRef.current = socket;

    const reloadOnceAfterDisconnect = () => {
      const alreadyReloaded = sessionStorage.getItem(RELOAD_LOCK_KEY);

      if (alreadyReloaded) return;

      sessionStorage.setItem(RELOAD_LOCK_KEY, 'true');

      reloadTimer = setTimeout(() => {
        window.location.reload();
      }, 1000);
    };

    socket.on('connect', () => {
      reconnectAttemptsRef.current = 0;
      setConnectionStatus('Connected');
      setNotificationServerDown(false);
      console.log(`Connected ${socket.id} ${formattedDateTime()}`);
    });

    socket.on('disconnect', (reason) => {
      setConnectionStatus('Disconnected: ' + reason);
      setNotificationServerDown(true);

      console.log(`Disconnected Notification ${reason} ${formattedDateTime()}`);

      // reload only after real disconnect
      reloadOnceAfterDisconnect();
    });

    socket.on('reconnect_attempt', (attemptNumber) => {
      reconnectAttemptsRef.current = attemptNumber;
      setConnectionStatus(`Reconnecting... Attempt ${attemptNumber}`);
      console.log(`Reconnection attempt #${attemptNumber}`);
    });

    socket.on('reconnect', () => {
      setNotificationServerDown(false);
      setConnectionStatus('Reconnected successfully');
      console.log('Notification server reconnected successfully');
    });

    socket.on('reconnect_failed', () => {
      setConnectionStatus('Reconnection failed');
      setNotificationServerDown(true);
      console.error('Notification server reconnection failed');
    });

    socket.on('connect_error', (e) => {
      console.log(`Socket Server is down ${e.message} ${formattedDateTime()}`);
      setNotificationServerDown(true);
    });

    socket.on('socket-auth-error', (data) => {
      if (data?.message === 'Invalid token') {
        console.log('Logout user because token is invalid');
        triggerLogout();
        setNotificationServerDown(true);
      }
    });

    const handleCustomerSocketData = async (arg, callback) => {
      try {
        console.log(`📶 Pong from Notification Server and data ${formattedDateTime()}`, arg);

        if (arg?.order_no) {
          updateOrderData(arg);
        }

        if (typeof callback === 'function') {
          callback({
            received: true,
            customerEmail: EmailAddress,
            order_no: arg?.order_no || null,
            redisKey: arg?.redisKey || null,
            receivedAt: new Date().toISOString(),
            message: 'Customer frontend received data successfully',
          });
        }
      } catch (error) {
        console.error('Error processing customer socket data:', error);

        if (typeof callback === 'function') {
          callback({
            received: false,
            customerEmail: EmailAddress,
            error: error.message,
            receivedAt: new Date().toISOString(),
            message: 'Customer frontend failed to process data',
          });
        }
      }
    };

    const pingInterval = setInterval(
      () => {
        if (socket.connected) {
          socket.emit('ping-from-customer');
          console.log(`📡 Sent ping ${formattedDateTime()}`);
        }
      },
      5 * 60 * 1000
    );

    socket.on(`pong-${EmailAddress}`, handleCustomerSocketData);
    socket.on(EmailAddress, handleCustomerSocketData);

    return () => {
      if (reloadTimer) clearTimeout(reloadTimer);
      clearInterval(pingInterval);
      socket.off(`pong-${EmailAddress}`, handleCustomerSocketData);
      socket.off(EmailAddress, handleCustomerSocketData);
      socket.disconnect();
    };
  }, [EmailAddress]);

  useEffect(() => {
    //Get order Live status, from API we are senting email
    GetOrderStatus(payload);

    if (notificationServerDown) {
      let Interval = null;
      const handleVisiblityChange = (event) => {
        if (document.visibilityState === 'visible') {
          // console.log("tab is Active visible")
          GetOrderStatus(payload);
          Interval = setInterval(() => {
            GetOrderStatus(payload);
            // console.log('-----setInterval triggered live status')
          }, 100000);
        } else {
          console.log('tab is NOT Active');
          clearInterval(Interval);
        }
      };
      document.addEventListener('visibilitychange', handleVisiblityChange);
      return () => {
        console.log('unmount');
        document.removeEventListener('visibilitychange', handleVisiblityChange);
        clearInterval(Interval);
      };
    }
  }, []);

  const stepsMapping = {
    pending: 'Pending',
    'order canceled by customer': 'Canceled by customer',
    'order accepted by kitchen': 'Preparing your order',
    'order canceled by kitchen': 'Canceled by restaurant',
    'order canceled by computer no response from kitchen': 'Sorry order canceled',
    'super admin canceled the order': 'Canceled by customer',

    'order ready for pickup': 'Searching for driver',
    'driver pickup pending': 'Searching for driver',
    'driver picked the order': 'Driver Picked order',
    order_unpicked_by_driver: 'Searching for driver',
    'order picked in store by customer': 'Order picked by customer',

    'driver is at the door': 'Driver waiting at the door',
    'order delivered': 'Order delivered',
    order_damaged_while_delivery: 'Sorry order damaged refunded',
  };

  const StatusStepper = ({ el, joinedOrders, orderType }) => {
    const PickData = joinedOrders ? el.mealOrder : el;
    const orderStatus = joinedOrders
      ? el.mealOrder?.internal_order_status
      : el.internal_order_status;
    const isFirstStep = firstProgress.includes(orderStatus);
    const isSecondStep = secondProgress.includes(orderStatus);
    const isThirdStep = thirdProgress.includes(orderStatus);

    return (
      <div
        style={{
          border: isMobile && !checkUrlOrderConfirm ? 'none' : '1px solid rgb(210, 210, 210)',
          borderRadius: '5px',
          margin: '10px 0px 10px 0px',
          padding: isMobile && checkUrlOrderConfirm ? '20px 20px 20px 0px' : '0px 20px 0px 0px',
          width: isMobile ? 'auto' : '680px',
          height: isMobile && !checkUrlOrderConfirm ? 'auto' : 'auto',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div
            style={{
              margin: isMobile ? '10px 0px 3px 19px' : '10px 10px 3px 19px',
              fontFamily: 'Inter Light',
              fontSize: '12px',
              letterSpacing: '0.2px',
            }}
          >
            {' '}
            {'Your order from -'}{' '}
            <span
              style={{
                fontFamily: 'Inter Bold',
                fontSize: '12px',
                letterSpacing: '0.4px',
                color: '#181436',
              }}
            >
              {PickData?.kitchen_name}
            </span>
          </div>

          <button
            style={{
              margin: isMobile ? '10px 0px 3px 0px' : '10px 0px 3px 19px',
              color: '#181436',
              border: '1px solid rgb(139, 137, 149)',
              borderRadius: '3px',
              fontFamily: 'Inter Medium',
              fontSize: '10px',
              letterSpacing: '0.5px',
              cursor: 'pointer',
            }}
            onClick={() => {
              handleClickRedirect();
            }}
          >
            Order Detail
          </button>
        </div>

        <div
          style={{
            margin: '0px 10px 10px 19px',
            letterSpacing: '0.2px',
            fontFamily: 'Inter Light',
            fontSize: '12px',
          }}
        >
          {' '}
          {PickData?.delivery_type === 'home delivery' ? 'Estimated arrival - ' : 'Pickup - '}
          <span
            style={{
              fontFamily: 'Inter Bold',
              fontSize: '12px',
              letterSpacing: '0.4px',
              color: '#181436',
            }}
          >
            {PickData?.delivery_time_slot}
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <LinearProgress
              variant={
                isFirstStep &&
                orderStatus !== 'super admin canceled the order' &&
                orderStatus !== 'order canceled by kitchen' &&
                orderStatus !== 'order canceled by computer no response from kitchen' &&
                orderStatus !== 'order canceled by customer'
                  ? 'indeterminate'
                  : 'determinate'
              }
              color={
                orderStatus === 'order canceled by kitchen' ||
                orderStatus === 'order canceled by customer' ||
                orderStatus === 'super admin canceled the order' ||
                orderStatus === 'order canceled by computer no response from kitchen'
                  ? 'error'
                  : 'warning'
              }
              value={100}
              sx={{ marginLeft: '20px' }}
            />
            {isFirstStep ? (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 5,
                  fontFamily: 'Inter Medium',
                  color:
                    orderStatus === 'order canceled by kitchen' ||
                    orderStatus === 'order canceled by customer' ||
                    orderStatus === 'order canceled by computer no response from kitchen' ||
                    orderStatus === 'super admin canceled the order'
                      ? 'red'
                      : '#181436',
                  fontSize: '12px',
                }}
              >
                {' '}
                {stepsMapping[orderStatus]}{' '}
              </div>
            ) : (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 10,
                  fontFamily: 'Inter Medium',
                  fontSize: '12px',
                }}
              >
                {' '}
                Restaurant accepted
              </div>
            )}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <LinearProgress
              variant={isSecondStep ? 'indeterminate' : 'determinate'}
              color='warning'
              sx={{ marginLeft: '20px' }}
              value={isFirstStep ? 0 : 100}
            />

            {isSecondStep && PickData?.delivery_type === 'pickup' && (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 10,
                  fontFamily: 'Inter Medium',
                  fontSize: '12px',
                }}
              >
                Order ready for pickup{' '}
              </div>
            )}
            {isThirdStep && PickData?.delivery_type === 'pickup' && (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 10,
                  fontFamily: 'Inter Medium',
                  fontSize: '12px',
                }}
              >
                {' '}
                Order Picked
              </div>
            )}

            {isSecondStep && PickData?.delivery_type === 'home delivery' && (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 10,
                  fontFamily: 'Inter Medium',
                  fontSize: '12px',
                }}
              >
                {' '}
                {stepsMapping[orderStatus]}{' '}
              </div>
            )}
            {isThirdStep && PickData?.delivery_type === 'home delivery' && (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 10,
                  fontFamily: 'Inter Medium',
                  fontSize: '12px',
                }}
              >
                {' '}
                Driver Picked order{' '}
              </div>
            )}
          </div>

          {PickData?.delivery_type === 'home delivery' && (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <LinearProgress
                variant={
                  isThirdStep &&
                  orderStatus !== 'order delivered' &&
                  orderStatus !== 'order_damaged_while_delivery'
                    ? 'indeterminate'
                    : 'determinate'
                }
                color={orderStatus === 'order_damaged_while_delivery' ? 'error' : 'warning'}
                sx={{ marginLeft: '20px' }}
                value={isFirstStep || isSecondStep ? 0 : 100}
              />
              {isThirdStep && (
                <div
                  style={{
                    marginLeft: 20,
                    marginTop: 10,
                    fontFamily: 'Inter Medium',
                    fontSize: '12px',
                    color: orderStatus === 'order_damaged_while_delivery' ? 'red' : '#181436',
                  }}
                >
                  {' '}
                  {stepsMapping[orderStatus]}{' '}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  if (LoadingStatus && !isMobile) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          border: isMobile && !checkUrlOrderConfirm ? 'none' : '1px solid rgb(210, 210, 210)',
          borderRadius: '5px',
          margin: '10px 0px 10px 0px',
          padding: isMobile && checkUrlOrderConfirm ? '20px 20px 20px 0px' : '20px 20px 20px 0px',
          width: isMobile ? 'auto' : '680px',
          height: isMobile && !checkUrlOrderConfirm ? 'auto' : 'auto',
        }}
      >
        <Loader color='#181436' width='20px' height='20px' />
        <div
          style={{
            fontFamily: 'Inter Light',
            fontSize: '14px',
            marginLeft: '5px',
            color: '#181436',
          }}
        >
          Loading order status
        </div>
      </div>
    );
  }

  if (openLiveOrderTracking && !checkUrlOrderConfirm && isMobile) {
    return (
      <SwipeableDrawer
        anchor='bottom'
        open={openLiveOrderTracking}
        onClose={() => {
          setOpenLiveOrderTracking(false);
        }}
        onOpen={() => {
          setOpenLiveOrderTracking(true);
        }}
        swipeAreaWidth={56}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
        style={{ zIndex: 1000, height: '500px' }}
        container={drawerContainerRef.current}
      >
        {LoadingStatus && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              padding: '20px',
            }}
          >
            <Loader color='#181436' width='20px' height='20px' />
            <div
              style={{
                fontFamily: 'Inter Light',
                fontSize: '14px',
                marginLeft: '5px',
                color: '#181436',
              }}
            >
              Loading order status
            </div>
          </div>
        )}

        {LoadingStatus === false &&
          Dta?.joinedOrders?.map((el, index) => {
            return StatusStepper({ el: el, joinedOrders: true, orderType: 'joinedOrders' });
          })}

        {LoadingStatus === false &&
          Dta?.mealOrders?.map((el, index) => {
            return StatusStepper({ el: el, joinedOrders: false, orderType: 'mealOrders' });
          })}

        {LoadingStatus === false &&
          Dta?.payAsYouGoOrders?.map((el, index) => {
            return StatusStepper({ el: el, joinedOrders: false, orderType: 'payAsYouGoOrders' });
          })}
        {LoadingStatus === false &&
          Dta?.PromotionalOrders?.map((el, index) => {
            return StatusStepper({ el: el, joinedOrders: false, orderType: 'PromotionalOrders' });
          })}

        <div style={{ height: '100px', width: '95%', color: 'white' }}>
          keeping space for footer
        </div>
      </SwipeableDrawer>
    );
  }

  return (
    <>
      {Dta?.joinedOrders?.map((el, index) => {
        return StatusStepper({ el: el, joinedOrders: true, orderType: 'joinedOrders' });
      })}

      {Dta?.mealOrders?.map((el, index) => {
        return StatusStepper({ el: el, joinedOrders: false, orderType: 'mealOrders' });
      })}

      {Dta?.payAsYouGoOrders?.map((el, index) => {
        return StatusStepper({ el: el, joinedOrders: false, orderType: 'payAsYouGoOrders' });
      })}
      {Dta?.PromotionalOrders?.map((el, index) => {
        return StatusStepper({ el: el, joinedOrders: false, orderType: 'PromotionalOrders' });
      })}
    </>
  );
};

export default OrderTrackingLive;
